import { useEffect } from "react";
import getPkce from "oauth-pkce";
import { getLocalValue, saveLocalValue } from "../Logic/storage";
import { iAuth, iIdentityProvider, iToken } from "./types";
import { getToken, parseJwt, refreshIDPToken } from "./TokenManager";
import Loading from "../Generic/loading";
import { useNavigate } from "react-router";
function OAuthLogin() {
    const navigate = useNavigate();
    useEffect(() => {
        async function checkAuthTokens() {
            const crypto = getLocalValue<iAuth>("auth");
            if (crypto == null) {
                await authenticate();
                return;
            }

            if (window.location.href.indexOf("code=") > 0) {
                let paramaters = window.location.href.substring(window.location.href.indexOf("?") + 1).split("&");
                let tenantRedirect = "";
                for (var i = 0; i < paramaters.length; i++) {
                    if (paramaters[i].indexOf("code=") > -1) {
                        crypto.code = paramaters[i].substring(5);
                        saveLocalValue("auth", crypto);
                    }

                    if (paramaters[i].substring(0, 6) === "state=") {
                        tenantRedirect = paramaters[i].substring(6);
                    }
                }
                getToken(crypto).then(data => {
                    crypto.token = data;
                    saveLocalValue("auth", crypto);
                    navigate("/");
                });
            } else {
                refreshIDPToken();
            }
        }
        checkAuthTokens();
    });

    async function authenticate() {
        var urlParts = window.location.href.substring(window.location.href.indexOf("://") + 3).split("/");
        let refererUri = "&state=";
        for (var i = 0; i < urlParts.length; i++) {
            if (urlParts[i].indexOf("?_referer=") > -1) {
                refererUri += encodeURIComponent(urlParts[i].replace("?_referer=", ""));
            }
        }
        const idp = await getIdentityProvider();
        getPkce(50, (error, { verifier, challenge }) => {
            //let crypto:iAuth = getPKSEKeys();
            let crypto: iAuth = {
                token: {} as iToken,
                code: "",
                verifier: verifier,
                challenge: challenge,
                ...idp,
            };
            saveLocalValue("auth", crypto);

            let vv =
                "?client_id=" +
                crypto.clientId +
                "&response_type=" +
                crypto.responseType +
                "&scope=" +
                crypto.scope +
                "&redirect_uri=" +
                encodeURIComponent(window.location.origin + "/auth/callback") +
                "&code_challenge=" +
                crypto.challenge +
                "&code_challenge_method=S256" +
                refererUri;
            let aa = crypto.authorizeUrl + vv;
            window.location.href = aa;
        });
    }
    async function getIdentityProvider(): Promise<iIdentityProvider> {
        var fetchOptions: any = {};
        fetchOptions.method = "GET";
        let response = await fetch(getSTSUrl() + "IdentityProviders", fetchOptions);
        return response.json();
    }

    const getSTSUrl = () => {
        let sURL = process.env.REACT_APP_STS;
        if (!sURL || sURL.length === 0) {
            var str = window.location;
            let stringtoReplaces = str.origin.substring(
                str.protocol.length + 2,
                str.origin.indexOf(".", str.protocol.length + 2),
            );
            sURL = str.origin.replace(stringtoReplaces, "sts");
        }
        if (!sURL.endsWith("/")) {
            sURL += "/";
        }

        return sURL;
    };

    return (
        <>
            <Loading />
        </>
    );
}
export default OAuthLogin;
